import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTE_CONSTANTS } from '../../constants/RouteConstants';
import { TokenService } from '../token-service/token-service';
import { AuthService } from '../auth-service/auth.service';
import { ToasterService } from '../toaster-service/toaster-service';
import { CONSTANTS } from '../../constants/Constants';
import jwt_decode from 'jwt-decode';

import Cookies from 'universal-cookie'


const TokenHandler = () => {
    const history = useHistory();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const authToken = urlParams.get('authToken');

        console.log("authToken", authToken)
        if (authToken) {
            callBackend(authToken);
        } else {
            history.push(ROUTE_CONSTANTS.LOGIN); // Redirect to login if no token
        }
    }, [history]);

    const callBackend = async (token: string) => {
        const payload: any = {
            token: token
        }
        console.log("here", payload)
        try {
            
            const response = await AuthService.ssologin(payload);
            console.log("resposse", response.data.token)
            if (response.hasError) {
                console.log("inside error")
                ToasterService.show("Failed to redirect to MDM", CONSTANTS.ERROR)
                history.push(ROUTE_CONSTANTS.LOGIN);
            } else {
                console.log("inside response")
                const decodedToken: any = jwt_decode(response.data.token);
                console.log('decodedTokens', decodedToken);
                const decodedUserName = decodedToken?.username;
                const decodedDesignation = decodedToken?.designation;
                localStorage.setItem('decodedUserName', decodedUserName);
                decodedDesignation && localStorage.setItem('decodedDesignation', decodedDesignation);
               
                TokenService().setToken(
                    response?.data?.token,
                    response?.data?.token
                )
                // storeCookie()
                ToasterService.show('Successfully redirected to MDM.', CONSTANTS.SUCCESS)
                history.push(ROUTE_CONSTANTS.LAYOUT)
            }

          
        } catch (error) {
            console.error('Error calling backend:', error);
            ToasterService.show("Failed to redirect", CONSTANTS.ERROR)
            history.push(ROUTE_CONSTANTS.LOGIN);


        }
    };

    return <div>Processing....</div>;
};

export default TokenHandler;

